import { render, staticRenderFns } from "./BetgameEditRules.vue?vue&type=template&id=1b5a41a7&scoped=true"
import script from "./BetgameEditRules.vue?vue&type=script&lang=js"
export * from "./BetgameEditRules.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditRules.vue?vue&type=style&index=0&id=1b5a41a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a41a7",
  null
  
)

export default component.exports